import styled, { css } from 'styled-components';
import get from 'lodash/get';

function guitar(t) {
    // type StylePath = FlatKeys<T>
    // type Base = GuitarBaseElement
    // type DefaultProps = Record<"theme",any>
    // type PropsFor<Definition extends StylePath> =
    //   Partial<FlatValue<T, Definition> & DefaultProps>
    // type GuitarComponent<BaseComponent extends Base, Definition extends StylePath> =
    //   BaseComponent extends ElementName 
    //     ? ComponentType<ComponentProps<BaseComponent> & PropsFor<Definition>>
    //     : BaseComponent extends ComponentType<infer C>
    //       ? ComponentType<C & PropsFor<Definition>>
    //       : never
    // type MakeGuitarComponent =
    //   <BaseComponent extends Base, Definition extends StylePath>(b:BaseComponent,k:Definition) => GuitarComponent<BaseComponent,Definition>
    const lookup = (base, key) => {
        const def = get(t, key);
        if (!def) {
            throw new Error(`${key} does not point to a valid guitar definition.`);
        }
        return styled(base) `${def}`;
    };
    return lookup;
}

function strsToTemplateStr(strs) {
    return Object.assign(strs, {
        raw: strs
    });
}
function block(...rulings) {
    const strings = strsToTemplateStr(["\n", ...Array.from({ length: rulings.length }).map(s => ";\n")]);
    const def = css(strings, ...rulings);
    return def;
}

function media(query) {
    return (strings, ...values) => css `
    @media ${query} {
      ${css(strings, ...values)}
    }
  `;
}

const noParse = x => () => x;
const dashed = (camelString) => camelString.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
function renderCSS(prop, val) {
    const [next, ...rest] = prop.split('.').reverse();
    return rest.reduce((css, next) => `${next} {
    ${css}
  }`, `${next}: ${val};`);
}
const makeRule = (options) => {
    const definedMedias = options.media || {};
    const defaultParser = options.defaultParser || noParse;
    function rule(param, defaultValue, options = {}) {
        const { parser = defaultParser, hover: defaultHover, media: defaultMedia, cssProperty } = options;
        const cssPropertyName = cssProperty || dashed(param);
        const styling = css `
      ${(props) => (props[`$${param}`] || defaultValue) && `${renderCSS(cssPropertyName, parser(props[`$${param}`] || defaultValue)(props))}`};
      ${(props) => {
            const medias = props[`$${param}Media`];
            if (medias || defaultMedia) {
                const grouped = Object.assign({}, (defaultMedia || {}), (medias || {}));
                return Object.keys(grouped).map(target => {
                    const value = grouped[target];
                    return css `
              ${media((definedMedias && target in definedMedias) ? definedMedias[target] : target) `
                ${renderCSS(cssPropertyName, parser(value)(props))}
              `}
            `;
                }).reduce((all, next) => css `
            ${all}
            ${next}
          `, css ``);
            }
            else {
                return null;
            }
        }}
      ${(props) => {
            const hover = props[`$${param}Hover`] || defaultHover;
            if (hover) {
                return css `
            &:hover {
              ${renderCSS(cssPropertyName, parser(hover)(props))}
            }
          `;
            }
            else {
                return null;
            }
        }}
    `;
        return styling;
    }
    return rule;
};
const plain = makeRule({});

export { block, guitar as default, makeRule, plain as rule };
